/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * YouTube 공개 설정
 */
export type PlaylistUploadToYoutubeRequestPrivacyStatus =
  (typeof PlaylistUploadToYoutubeRequestPrivacyStatus)[keyof typeof PlaylistUploadToYoutubeRequestPrivacyStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaylistUploadToYoutubeRequestPrivacyStatus = {
  public: "public",
  unlisted: "unlisted",
  private: "private",
} as const;
